import React, { createContext, useState, useMemo } from "react";
import { DEFAULT_USAGE_TYPE, normalizeUsageType } from "../constants";
export var MainContext = createContext({
    lang: "es",
    idLogo: null,
    token: null,
    apiKey: null,
    tracking: "auto",
    usageType: DEFAULT_USAGE_TYPE,
    setApiKey: function () { },
    setTracking: function () { },
    environment: null,
    accessToken: null,
    getFromUrl: function () { },
});
export var MainProvider = function (_a) {
    var children = _a.children;
    var _b = useState("es"), lang = _b[0], setLang = _b[1];
    var _c = useState(null), idLogo = _c[0], setIdLogo = _c[1];
    var _d = useState(null), token = _d[0], setToken = _d[1];
    var _e = useState(null), apiKey = _e[0], setApiKey = _e[1];
    var _f = useState(null), environment = _f[0], setEnviroment = _f[1];
    var _g = useState(null), accessToken = _g[0], setAccessToken = _g[1];
    var _h = useState(false), leyend = _h[0], setLeyend = _h[1];
    var _j = useState("auto"), tracking = _j[0], setTracking = _j[1];
    var _k = useState(DEFAULT_USAGE_TYPE), usageType = _k[0], setUsageType = _k[1];
    var getFromUrl = function (location) {
        var params = new URLSearchParams(location.search);
        setLang(params.get("lang"));
        setIdLogo(params.get("logo"));
        setToken(params.get("token"));
        setApiKey(params.get("apikey"));
        setEnviroment(params.get("env"));
        setAccessToken(params.get("accesstoken"));
        setLeyend(params.get("leyend"));
        var selfTranking = params.get("tracking") || "auto";
        setTracking(selfTranking);
        var selfUsageType = normalizeUsageType(params.get("usagetype"));
        setUsageType(selfUsageType);
        return {
            lang: params.get("lang") || lang,
            idLogo: params.get("logo"),
            token: params.get("token"),
            apiKey: params.get("apikey"),
            environment: params.get("env"),
            accessToken: params.get("accesstoken"),
            margin: params.get("margin"),
            leyend: params.get("leyend"),
            tracking: selfTranking,
            usageType: selfUsageType,
        };
    };
    var value = useMemo(function () {
        return {
            lang: lang,
            idLogo: idLogo,
            token: token,
            apiKey: apiKey,
            environment: environment,
            accessToken: accessToken,
            setApiKey: setApiKey,
            getFromUrl: getFromUrl,
            leyend: leyend,
            tracking: tracking,
            usageType: usageType,
        };
    }, [
        lang,
        idLogo,
        token,
        apiKey,
        environment,
        accessToken,
        setApiKey,
        tracking,
        usageType,
        getFromUrl,
    ]);
    return React.createElement(MainContext.Provider, { value: value }, children);
};
